import { Box, Tab, Tabs, Typography } from "@mui/material";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { DETAIL_TAB_INDEX, DETAIL_TABS } from "../../data";
import {
  selectActiveDetailTab,
  selectSelectedVehicleDetail,
} from "../../redux/selector";
import { actions } from "../../redux/slice";
import DetailsTab from "./DetailsTab";
import NotesTab from "./NotesTab";
import ProductionTab from "./ProductionTab";
import TestsTab from "./TestsTab";
import WeightsTab from "./WeightsTab";
import { useStyles } from "./styles";

const DETAIL_TAB_CONTENT: Record<number, React.ReactNode> = {
  [DETAIL_TAB_INDEX.NOTES]: <NotesTab />,
  [DETAIL_TAB_INDEX.TESTS]: <TestsTab />,
  [DETAIL_TAB_INDEX.WEIGHTS]: <WeightsTab />,
  [DETAIL_TAB_INDEX.PRODUCTION]: <ProductionTab />,
  [DETAIL_TAB_INDEX.DETAILS]: <DetailsTab />,
};

const VehicleDetailCard = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const vehicleDetail = useSelector(selectSelectedVehicleDetail);
  const activeDetailTab = useSelector(selectActiveDetailTab);

  if (!vehicleDetail) {
    return null;
  }

  return (
    <Box
      className={styles.card}
      dir={(i18n.language || "hw").startsWith("hw") ? "rtl" : "ltr"}
    >
      <Box className={styles.header}>
        <Typography className={styles.title}>
          {t(vehicleDetail.titleKey)}
        </Typography>
        <Typography className={styles.subtitle}>
          {t(`VECHILE_STATUS.STATUS_VALUES.${vehicleDetail.subtitle.makeModelKey}`)}
          {"  "}
          {t("VECHILE_STATUS.DETAIL.HEADER_REGISTRATION")}:{" "}
          {vehicleDetail.subtitle.licenseNumber}
          {"  "}
          {t("VECHILE_STATUS.DETAIL.HEADER_CHASSIS")}:{" "}
          {vehicleDetail.subtitle.chassisNumber}
        </Typography>
      </Box>

      <Box
        className={clsx(
          styles.body,
          activeDetailTab === DETAIL_TAB_INDEX.NOTES && styles.bodyNotesTab
        )}
      >
        <Box className={styles.badges}>
          {vehicleDetail.badges.map((badge) => (
            <span
              key={badge.id}
              className={
                badge.variant === "danger"
                  ? styles.badgeDanger
                  : styles.badgeDefault
              }
            >
              {badge.valueKey ? (
                <>
                  <span className={styles.badgeLabel}>{t(badge.labelKey)}:</span>{" "}
                  <span className={styles.badgeValue}>{t(badge.valueKey)}</span>
                </>
              ) : (
                t(badge.labelKey)
              )}
            </span>
          ))}
        </Box>

        <Tabs
          className={styles.tabs}
          value={activeDetailTab}
          onChange={(_, value) => dispatch(actions.setActiveDetailTab(value))}
          variant="fullWidth"
        >
          {DETAIL_TABS.map((item, index) => (
            <Tab key={item.id} label={t(item.labelKey)} value={index} />
          ))}
        </Tabs>

        <Box
          className={clsx(
            styles.content,
            activeDetailTab === DETAIL_TAB_INDEX.NOTES && styles.contentNotesTab
          )}
        >
          {DETAIL_TAB_CONTENT[activeDetailTab]}
        </Box>
      </Box>
    </Box>
  );
};

export default VehicleDetailCard;
